import angular from 'angular'
import { statisticsPurchaseRank } from 'redevConfig'
const list = (statisticsPurchaseRank && statisticsPurchaseRank.list) || ''
const detail = (statisticsPurchaseRank && statisticsPurchaseRank.detail) || ''

const statisticsPurchaseRankList = list ? require(`redevelopment/statistics/statisticsPurchaseRank/${list.templateName}`) : require('./view/statisticsPurchaseRankList.html')
const statisticsPurchaseRankListCtrl = list ? require(`redevelopment/statistics/statisticsPurchaseRank/${list.controllerName}`) : require('./statisticsPurchaseRankListCtrl')

const statisticsPurchaseRankDetail = detail ? require(`redevelopment/statistics/statisticsPurchaseRank/${detail.templateName}`) : require('./view/purchaseRankDetail.html')
const statisticsPurchaseRankDetailCtrl = detail ? require(`redevelopment/statistics/statisticsPurchaseRank/${detail.controllerName}`) : require('./statisticsPurchaseRankDetailCtrl')
export default angular
    .module('app.statisticsPurchaseRank', [])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state('statistics.inputStatistics.statisticsPurchaseRank', {
                abstract: true,
                url: '/statisticsPurchaseRank',
                template: '<div ui-view></div>',
                title: '采购排名',
                default: 'statistics.inputStatistics.statisticsPurchaseRank.list',
            })
            .state('statistics.inputStatistics.statisticsPurchaseRank.list', {
                url: '/list',
                template: statisticsPurchaseRankList,
                controller: 'statisticsPurchaseRankListCtrl',
            })
            .state('statistics.inputStatistics.statisticsPurchaseRank.detail', {
                url: '/detail/:params/:type',
                template: statisticsPurchaseRankDetail,
                controller: 'statisticsPurchaseRankDetailCtrl',
                title: '排名详情',
            })
    }])
    // .controller('statisticsPurchaseRankCtrl', statisticsPurchaseRankCtrl)
    .controller('statisticsPurchaseRankListCtrl', statisticsPurchaseRankListCtrl.default)
    .controller('statisticsPurchaseRankDetailCtrl', statisticsPurchaseRankDetailCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/statistics/inputStatistics/statisticsPurchaseRank/index.js